var videoObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    const video = entry.target;
    
    // Function to attempt video play
    const tryPlayVideo = () => {
      if (entry.isIntersecting) {
        video.play().catch(e => console.error("Error attempting to play video:", e));
      }
    };

    // Check if the video is loaded
    if (video.readyState >= 2) { // 2 = HAVE_CURRENT_DATA
      tryPlayVideo();
    } else {
      // If the video hasn't loaded yet, listen for the loadeddata event
      video.addEventListener('loadeddata', () => {
        tryPlayVideo();
      }, { once: true }); // Use { once: true } to ensure the event listener is removed after firing once
    }

    // Handle leaving the viewport
    if (!entry.isIntersecting) {
      video.pause();
    }
  });
}, {});

let videos = [...document.querySelectorAll('video')];
videos.forEach(video => {
  videoObserver.observe(video);  
});
